import { Component, input } from '@angular/core';

@Component({
  selector: 'avs-incident-count-badge',
  styleUrl: './incident-count-badge.component.scss',
  template: `
    <div class="incident-count-badge">
      <span class="count">{{ count() }}</span>
      Incident{{ count() === 1 ? '' : 's' }}
    </div>
  `,
})
export class IncidentCountBadgeComponent {
  count = input.required<number>();
}
